import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import { FuelModel } from '../../Models/MiniGames/FuelModel';

@Singleton
export class FuelLogic {
    constructor(
        @Inject private _model: FuelModel,
        @Inject private _modelEvents: ModelEvents,
    ) {
    }

    public currentStep(): number {
        return this._model.step;
    }

    public nextStep(): boolean {
        return ++this._model.step === this._model.steps + 1;
    }

    public reset(): void {
        this._model.step = 1;
    }
}
